<div *ngIf="task; else no_tasks">
    <h2 *ngIf="task.isProcess;else Zoning_code_statistic" mat-dialog-title
        ngClass="{{task.isStep ? 'modal-step-header' : ''}}">{{ task.isStep ? 'Step ' + task.stepIndex + ':
        ' : ''}}{{ task.typeStr }}</h2>
    <h4>{{task.hasSteps ? 'Summary:' : 'Statistic:'}}</h4>

    <div class="mat-typography">
        <app-process-status-row [process]="task"></app-process-status-row>
        <app-process-statistic-section [process]="task"></app-process-statistic-section>

        <app-process-stats-by-status-section [process]="task"></app-process-stats-by-status-section>

        <app-data-source-category-view
            [dataSourceCategories]="task.dataSourceCategories"></app-data-source-category-view>

        <div *ngIf="task['syncSolrData'] !== undefined" class="mat-typography" style="margin-top: 15px;">
            <p>Send data to Solr: {{task?.syncSolrData?'Yes':'No'}}
            </p>
        </div>
    </div>

    <div *ngIf="task.solrGroupIdsStatistic">
        <h4 class="md-subhead">Synchronization with Solr - <app-solr-operations-status
                [data]="task.solrGroupIdsStatistic"></app-solr-operations-status></h4>
        <app-solr-group-ids-data-statistic [data]="task.solrGroupIdsStatistic">
        </app-solr-group-ids-data-statistic>
    </div>
</div>

<ng-template #no_tasks>
    <h2>Tasks are not found</h2>
</ng-template>